import { render, staticRenderFns } from "./automatic.vue?vue&type=template&id=bf0b1898&"
import script from "./automatic.vue?vue&type=script&lang=js&"
export * from "./automatic.vue?vue&type=script&lang=js&"
import style0 from "./automatic.vue?vue&type=style&index=0&id=bf0b1898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports